export const READY = 'READY'
export const NEED_INDEX = 'NEED_INDEX'
export const NEED_TOKEN = 'NEED_TOKEN'
export const CURRENT_USER = 'CURRENT_USER'
export const CURRENT_USER_COMPANIES = 'CURRENT_USER_COMPANIES'
export const CURRENT_USER_COMPANY_ID = 'CURRENT_USER_COMPANY_ID'
